import React from "react";

var Component = function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 20l-5.193 2.829c-1.008.563-2.188-.345-1.996-1.538l.986-6.118a.054.054 0 0 0-.015-.047l-4.411-4.56c-.726-.75-.326-2.058.676-2.213L8.14 7.41a.054.054 0 0 0 .038-.029L12 1",
    fill: "none",
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }));
};

Component.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
Component.displayName = "favorite-half";
export default Component;